import { HttpClient } from '@angular/common/http';
import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { GlobalService } from 'src/app/services/global.service';
import { MapServiceService } from '../../../services/Map-service/map-service.service';
import { SideNavService } from '../../../services/sidenav/side-nav.service';

import { ZoomToPerimeterService } from '../../../services/Zoom-to-Perimeter/zoom-to-perimeter.service';

@Component({
  selector: 'app-zoom-to-perimeter',
  templateUrl: './zoom-to-perimeter.component.html',
  styleUrls: ['./zoom-to-perimeter.component.css'],
})
export class ZoomToPerimeterComponent implements OnInit, OnDestroy {
  path: any;
  perimeterData: any;
  loadMap = false;
  getperimeterData: any;
  wkt: any;
  myExtent: any = [];
  clickedIndex: any;
  selectedFeatures: any;
  singleData: any;
  json: any;

  constructor(
    public SideNavService: SideNavService,
    public activatedRoute: ActivatedRoute,
    public zoomToPerimeter: ZoomToPerimeterService,
    private global: GlobalService,
    private http: HttpClient,
    public mapService: MapServiceService
  ) {
    this.path = this.activatedRoute.snapshot.params['map'];
  }

  ngOnInit(): void {
    this.getAllZoomToPrimeter();
  }

  getPerimeter(data: any, i: any) {
    this.clickedIndex = i;
    this.getperimeterData = data;
    this.zoomToPerimeter.gcid = this.getperimeterData.gcid;
    this.json = { wildfire_perimeter_name: `${data.firename}` };
    this.json = JSON.stringify(this.json);
    this.getAllZoomToPrimeter();
  }

  getAllZoomToPrimeter() {
    if (!this.zoomToPerimeter.gcid) {
      this.zoomToPerimeter.gcid = '';
      this.global.toggleLoader(true);
      this.zoomToPerimeter.getZoomToPerimeter(this.path, 0).subscribe((res) => {
        if (res) {
          this.perimeterData = res;
          this.perimeterData.sort((a: any, b: any) => {
            return a.firename.localeCompare(b.firename, undefined, {
              numeric: true,
              sensitivity: 'base',
            });
          });

          this.global.toggleLoader(false);
        }
      });
    } else {
      this.global.toggleLoader(true);
      this.zoomToPerimeter
        .getZoomToPerimeter(this.path, this.zoomToPerimeter.gcid.toString())
        .subscribe((res) => {
          if (res) {
            this.mapService.selectedParcels = [];
            this.mapService.hideRunButton = true;
            this.selectedFeatures = res.features;
            this.singleData = res;
            const fields: any = {};
            if (this.selectedFeatures.length > 1) {
              this.mapService.parcel = '';
              this.mapService.parcels = [];
              for (let i = 0; i < this.selectedFeatures.length; i++) {
                this.mapService.multiParcelId.push(this.selectedFeatures[i].id);
                if (fields[this.selectedFeatures[i].layer_id]) {
                  fields[this.selectedFeatures[i].layer_id.toString()].push(
                    this.selectedFeatures[i].id.toString()
                  );
                } else {
                  fields[this.selectedFeatures[i].layer_id] = [];
                  fields[this.selectedFeatures[i].layer_id.toString()].push(
                    this.selectedFeatures[i].id.toString()
                  );
                }
                this.mapService.parcel = JSON.stringify(fields);
                this.mapService.featureLayersId.push(
                  this.selectedFeatures[i].layer_id
                );
                this.mapService.featureLayerId = [
                  ...new Set(this.mapService.featureLayersId),
                ].toString();
              }
            } else {
              this.mapService.parcel = '';
              this.mapService.parcels = [];
              for (let i = 0; i < this.selectedFeatures.length; i++) {
                this.mapService.multiParcelId.push(this.selectedFeatures[i].id);
                // multiParcel
                this.mapService.multiParcel = false;
                // parcel ID
                this.mapService.parcels.push(this.selectedFeatures[i].id);
                this.mapService.parcel = [
                  ...new Set(this.mapService.parcels),
                ].toString();
                // Feature Layer Id
                this.mapService.featureLayersId.push(
                  this.selectedFeatures[i].layer_id
                );
                this.mapService.featureLayerId = [
                  ...new Set(this.mapService.featureLayersId),
                ].toString();
              }
            }

            this.mapService.ParcelData = [];
            this.mapService.ParcelData = res.features;
            // localStorage.setItem('seletedFeature', JSON.stringify(res.features));
            this.SideNavService.decideComponent(this.singleData);
            this.SideNavService.decideComponent(res);
            this.global.toggleLoader(false);
          }
        });
    }
  }
  closeLeft() {
    this.mapService.closePanel = true;
    this.mapService.setClosePanel(true);
  }

  activityLoging() {
    this.http
      .get('https://api.ipify.org/?format=json')
      .subscribe((res: any) => {
        this.mapService.ipAddress = res.ip;
        const body = {
          map_id: this.mapService.mapId.toString(),
          event: 'Click',
          page: this.mapService.pageUrl,
          basemap: this.mapService.shareCurrentMap,
          event_name: 'WildfirePerimeter',
          ip: this.mapService.ipAddress,
          time: this.mapService.getTimeOnPage().toString(),
          event_information: this.json,
          point: '',
          wkt: '',
        };
        this.mapService.activityLogs(body).subscribe(
          () => {
            // console.log('a');
          },
          (error: any) => {
            if (error.status == 403) {
              location.reload();
            }
          }
        );
      });
  }
  @HostListener('unloaded')
  ngOnDestroy() {
    this.zoomToPerimeter.gcid = '';
  }
}
